import { F0AvatarPerson, F0Box, F0Select, F0Text } from '@factorialco/f0-react'
import type { PlanningValueObjectsParticipantRoleEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const isValidRole = (value: unknown): value is PlanningValueObjectsParticipantRoleEnum =>
  value === 'viewer' || value === 'editor'

export interface SelectedParticipant {
  employeeId: string
  role: PlanningValueObjectsParticipantRoleEnum
}

export interface EmployeeInfo {
  firstName: string
  lastName: string
  avatarUrl: string | undefined
}

interface ParticipantRowProps {
  participant: SelectedParticipant
  employee: EmployeeInfo | undefined
  onRoleChange: (employeeId: string, role: PlanningValueObjectsParticipantRoleEnum) => void
}

const ParticipantRow = ({ participant, employee, onRoleChange }: ParticipantRowProps) => {
  const ROLE_OPTIONS = [
    { value: 'viewer', label: i18n.t('planning.manage_collaborators.role_viewer') },
    { value: 'editor', label: i18n.t('planning.manage_collaborators.role_editor') },
  ]

  if (!employee) {
    return null
  }

  const fullName = `${employee.firstName} ${employee.lastName}`

  return (
    <F0Box display="flex" flexDirection="row" alignItems="center" justifyContent="between" gap="md">
      <F0Box display="flex" flexDirection="row" alignItems="center" gap="lg">
        <F0AvatarPerson
          firstName={employee.firstName}
          lastName={employee.lastName}
          src={employee.avatarUrl}
          size="sm"
        />
        <F0Text content={fullName} variant="label" />
      </F0Box>
      <F0Select
        label={i18n.t('planning.manage_collaborators.role_label')}
        hideLabel
        value={participant.role}
        onChange={(value: string) => {
          if (isValidRole(value)) {
            onRoleChange(participant.employeeId, value)
          }
        }}
        options={ROLE_OPTIONS}
      />
    </F0Box>
  )
}

export default ParticipantRow
